var exports = {
  "x6": "GuildListActionButton.module__button___Q0JNR2",
  "td": "GuildListActionButton.module__iconText___Q0JNR2",
  "ro": "GuildListActionButton.module__menuIcon___Q0JNR2",
};

module.exports = exports;
